import React from 'react'
import { MapTypeContext } from 'common/Map/MapTypeContext'
import { GooglePolyline } from 'common/Map/Polyline/GooglePolyline'
import { LeafletPolyline } from 'common/Map/Polyline/LeafletPolyline'
import { MapboxPolyline } from 'common/Map/Polyline/MapboxPolyline'
import { getConsole } from 'lib/getConsole'
const console = getConsole('Map', 'Polyline')

export class Polyline extends React.PureComponent {
  static defaultProps = {
    icon: 'default'
  }

  render () {
    const { positions, color, weight, onMouseEnter, onMouseLeave, onClick, showSurface } = this.props
    return <MapTypeContext.Consumer>
      {({ mapType, mapInstance }) => {
        switch (mapType) {
          case 'leaflet':
            return <LeafletPolyline
              positions={positions}
              color={color}
              weight={weight}
            />
          case 'google':
            return <GooglePolyline
              mapInstance={mapInstance}
              positions={positions}
              color={color}
              weight={weight}
              showSurface={showSurface}
            />
          case 'mapbox':
            return <MapboxPolyline
              mapInstance={mapInstance}
              positions={positions}
              color={color}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              onClick={onClick}
              weight={weight}
              showSurface={showSurface}
            />
          default:
            console.warn(`Polyline rendered with unknown mapType '${mapType}'`)
            return null
        }
      }}
    </MapTypeContext.Consumer>
  }
}
